import './CreateAOThird.scss';

import AddIcon from '@mui/icons-material/Add';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Autocomplete, Button, FormControl, IconButton, MenuItem, Select, ThemeProvider, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

import { buttonStyles, buttonStylesBlue, buttonStylesGreen } from '../../../Components/docsAdministrative/JsObjectStyles';
import { SelectComponent, TextFieldComponent } from '../../../Components/shared/ReusableSmallComponents';
import { exigencesEnum, foncSkillSet, languesList, niveauxLangue, niveauxSkill, niveauxSkillAo } from '../../../data/Interfaces';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import useCraRdv from '../../../hooks/useCraRdv';
import usePostRequest from '../../../hooks/usePostRequest';
import useRole from '../../../hooks/useRole';
import useUtilities from '../../../hooks/useUtilities';
import useWindowSize from '../../../hooks/useWindowSize';
import { FieldComponentFont } from '../../../Styles/componentStyles';
import { isHttpStatusSuccess } from '../../../Utils/utils';
import CompetenceComponent from '../../Admin/GestionExpert/CompetenceComponent';
import CreateAOButtonsHeader from './CreateAOButtonsHeader';

export const initializeTechSkill = (index) => {
    return {
        // ! this was the problem ! [] , I couldn't push titre to null && 'not array'
        // titre: [null],
        // titre: ['foo', 'bar'], //* used for chip input
        titre: '',//''
        niveau: null,
        //experiencePlusRecente: null,
        exigence: null,
        index: index,
    };
};

export const initializeFoncSkill = (index) => {
    return {
        titre: '',
        niveau: null,
        //experiencePlusRecente: null,
        exigence: null,
        index: index,
    };
};

export const initializeLangue = (index) => {
    return {
        langue: null,
        niveau: null,
        exigence: null,
        index: index,
    };
};

export const initializeCertif = (index) => {
    return {
        titre: '',
        exigence: null,
        index: index,
    };
};
export const initializeCertifCvTheque = (index) => {
    return {
        cerificat: '',
        exigence: null,
        index: index,
    };
};

function CreateAOThird() {
    const { selectedAO, setSelectedAO } = useCraRdv();
    const axiosPrivate = useAxiosPrivate();
    const location = useLocation();
    console.log('state step2', selectedAO);
    let navigate = useNavigate();
    const role = useRole();
    const { setBackdropOpen } = useUtilities();
    const [aoId, setAoId] = useState('');
    const { inputSize } = useWindowSize();
    const { postData } = usePostRequest();
    const [intitulePoste, setIntitulePoste] = useState();
    const { device } = useWindowSize();
    const [skillsTech, setSkillsTech] = useState([initializeTechSkill(0)]);

    const [skillsFonc, setSkillsFonc] = useState([initializeFoncSkill(0)]);

    const [langues, setLangues] = useState([initializeLangue(0)]);

    const [certifs, setCertifs] = useState([initializeCertif(0)]);
    const { i18n } = useTranslation();
    useEffect(() => {
        if (location?.state?.aoId) {
            getAoDataById();
        }
    }, [location?.state?.aoId]);

    useEffect(() => {
        console.log({ 'halo': selectedAO });
        if (selectedAO) {
            setBackdropOpen(true);
            setAoId(selectedAO?._id);
            initializeAOThird(selectedAO?.competencesData);
            if (selectedAO?._id && selectedAO?._id != '') {
                setBackdropOpen(false);
            }
            /*
row data was the AO info setted in drafs whyle selecting it and navigating to the proper step ( where we stoped)
payloaf 2 was the ao data passed from step 2 to the page 3, and the same for step 3,
but I thikn, we will set the new AO (after sauvegarde/suivant) each time the client clicks
 on the button this way we could easely have the selected AO with the saved data and the updated one with the backend each time, and we are not responsible if the ser clicks on retour and he didn't save the data .. he should save !
            */
            // let receivedAo = selectedAO?.rowData
            // || selectedAO?.payloadStep3
            // || selectedAO?.payloadStep2;
            // console.log({ receivedAo });
            // if (receivedAo) {
            //     console.log({ statecertif: selectedAO?.payloadStep3?.certifs });
            //     setAoId(receivedAo?._id);
            //     initializeAOThird(selectedAO?.rowData?.competencesData || selectedAO?.payloadStep3);
            // }
        }
    }, [selectedAO]);

    // useEffect(() => {
    //     if (aoId && aoId != '') {
    //         setBackdropOpen(false);
    //     }
    // }, [aoId]);

    const getAoDataById = async () => {
        setBackdropOpen(true);
        try {
            const response = await axiosPrivate.get('/ao/getMyAoById/' + location?.state?.aoId);
            setBackdropOpen(false);
            console.log(response?.data?.myAO);
            initializeAOThird(response?.data?.myAO?.competencesData);
            setIntitulePoste(response?.data?.myAO?.intitulePoste);
        } catch (error) {
            setBackdropOpen(false);
            console.log(error);
        }
    };
    const initializeAOThird = (recievedCompetencesData) => {
        if (Array.isArray(recievedCompetencesData?.skillsTech)) setSkillsTech(recievedCompetencesData?.skillsTech);
        if (Array.isArray(recievedCompetencesData?.skillsFonc)) setSkillsFonc(recievedCompetencesData?.skillsFonc);
        if (Array.isArray(recievedCompetencesData?.langues)) setLangues(recievedCompetencesData?.langues);
        if (Array.isArray(recievedCompetencesData?.certifs)) setCertifs(recievedCompetencesData?.certifs);
    };

    const navigateToStep2WithSavedData = () => {
        // let stateToPass = {
        //     // * l'_id de AO sera dans les deux Variables
        //     payloadStep2: selectedAO?.payloadStep2,
        //     payloadStep3: {
        //         _id: aoId,
        //         skillsTech,
        //         skillsFonc,
        //         langues,
        //         certifs
        //     }
        // };
        // setSelectedAO(stateToPass);
        navigate(`/${role}/createAO/next`);
    };

    const createAO_step3 = async ({ e, action }) => {
        e.preventDefault();
        console.log(skillsTech, skillsFonc, langues, certifs);
        const payloadStep3 = {
            action,
            skillsTech,
            skillsFonc,
            langues,
            certifs,
            // ! AMDIN case
            companyDataId: selectedAO?.companyDataId
        };
        let response1;
        // * in case of modification
        if (location?.state?.aoId) {
            response1 = await postData({ url: `/ao/updateAOById/${location?.state?.aoId}`, payload: { competencesData: payloadStep3 }, });
            if (isHttpStatusSuccess(response1.responseStatus))
                navigate(`/${role}/ao/aoDetails/${location?.state?.aoId}`);
        }
        // * in case of creation
        else {
            response1 = await postData({ url: '/ao/createAO_step3', payload: { ...payloadStep3, aoId } });
            console.log(response1);
            if (isHttpStatusSuccess(response1.responseStatus)) {
                setSelectedAO(response1?.data?.createdAO);
                if (action == 'validate') {
                    Swal.fire({
                        title: `<h1 style=color:'#214DCE'>${i18n.t('Félicitation!')}</h1>`,
                        // imageUrl: FelicitationIcon,
                        html: `<h2> ${i18n.t('Votre appel d\'offre a été créé avec succès sous la référence ')} ${response1?.data?.createdAO?.aoId}.<br>
                                        ${i18n.t('Une proposition des CVs les plus pertinents correspondant à votre appel d\'offre vous sera liée si des correspondances sont trouvées. Cela peut prendre quelques secondes.')}    </h2>`,
                        // '<br/> <p>Si vous souhaitez l\'utiliser comme "template" pour publier des besoins similaires à l\'avenir, veuillez cliquer sur "Template".</p>',
                        // confirmButtonColor: '#5CC889',
                        // confirmButtonText: 'Template',
                        showConfirmButton: false,
                        cancelButtonColor: '#88898f',
                        cancelButtonText: 'Retour', //'Non merci',
                        showCancelButton: true,
                    }).then((result) => {
                        console.log(result);
                        if (result.isConfirmed) {
                            alert('to be continued');
                        }
                        if (result.isDismissed) {
                            navigate(`/${role}/aos`);
                        }
                    });
                }
            }
        }
    };

    return (
        <>
            <div className='HomeAO2'>
                <CreateAOButtonsHeader
                    aoId={location?.state?.aoId}
                    intitulePoste={intitulePoste}
                    role={role}
                />
                <Accordion style={{ width: '100%' }}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                    >
                        <Typography><h6 className='titlesociete'>{i18n.t('Compétences techniques')}</h6></Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <div className='Frame121212'>
                            {Array.isArray(skillsTech) && skillsTech.map((skill, i) => (
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: device == 'desktop' ? 'row' : 'column',
                                        justifyContent: 'space-between',
                                        alignSelf: 'stretch',
                                        gap: '16px',
                                    }}
                                    key={i}
                                >
                                    <div style={{ width: device == 'desktop' ? '50%' : '100%' }}>
                                        <p className='row1skillnametxt2'>{i18n.t('Compétence')}</p>
                                        <CompetenceComponent
                                            skill={skill}
                                            index={i}
                                            skillsTech={skillsTech}
                                            setSkillsTech={setSkillsTech}
                                        />
                                        {/*<Autocomplete
                                            id="free-solo-2-demo"
                                            name='titre'
                                            size={inputSize}
                                            freeSolo

                                            inputValue={skill?.titre || ''}
                                            onInputChange={(event, newInputValue) => {
                                                console.log({ event, newInputValue, skillsTech });
                                                let newArr = [...skillsTech]; // copying the old datas array
                                                newArr[i].titre = newInputValue; // replace e.target.value with whatever you want to change it to
                                                setSkillsTech(newArr);
                                            }}
                                            sx={{
                                                '& > :not(style)': { borderRadius: '8px' },
                                            }}
                                            style={{ width: '100%', borderRadius: '8px' }}
                                            renderInput={(params) =>
                                                <TextFieldComponent
                                                    {...params}
                                                    sx={{
                                                        '& > :not(style)': { borderRadius: '8px' },
                                                    }}
                                                //onChange={(e)=>{
                                                //    handleInputChangeCompetencesTech(e,i);
                                                //}}
                                                //label=""
                                                //placeholder="Compétence technique"
                                                />}
                                        />*/}
                                    </div>

                                    <div style={{ width: device == 'desktop' ? '50%' : '100%' }}>
                                        <p className='row1skillnametxt2'>{i18n.t('Niveau')}</p>
                                        <SelectComponent
                                            val={skill?.niveau}
                                            name='niveau'
                                            setVal={(e) => {
                                                let newArr = [...skillsTech];
                                                newArr[i].niveau = e.target.value;
                                                setSkillsTech(newArr);
                                                console.log(e.target.value);
                                            }}
                                            listVal={niveauxSkillAo}
                                        />
                                    </div>

                                    <div style={{ width: device == 'desktop' ? '25%' : '100%' }}>
                                        <p className='row1skillnametxt2'>{i18n.t('Exigence')}</p>
                                        <SelectComponent
                                            name="exigence"
                                            val={skill?.exigence}
                                            setVal={(e) => {
                                                let newArr = [...skillsTech];
                                                newArr[i].exigence = e.target.value;
                                                setSkillsTech(newArr);
                                                console.log(e.target.value);
                                            }}
                                            listVal={exigencesEnum}
                                        />
                                    </div>

                                    <div className='btndelete'>
                                        <IconButton
                                            onClick={(e) => {
                                                const list = [...skillsTech];
                                                list.splice(i, 1);
                                                setSkillsTech(list);
                                                console.log(e, skillsTech);
                                            }}

                                            aria-label="delete"
                                        >
                                            <DeleteForeverOutlinedIcon />
                                        </IconButton>
                                    </div>
                                </div>
                            ))}

                            <Button

                                style={{ ...buttonStyles(false), ...{ color: '#B0B0B0' } }}
                                variant="text"
                                startIcon={<AddIcon />}
                                onClick={(e) => {
                                    let index = skillsTech.length;
                                    let newArr = [...skillsTech]; // copying the old datas array
                                    newArr.push(initializeTechSkill(index));
                                    setSkillsTech(newArr);
                                    console.log(e, skillsTech);
                                }}
                            >{i18n.t('Ajouter une compétence')}</Button>
                        </div>
                    </AccordionDetails>
                </Accordion>

                <Accordion style={{ width: '100%' }}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                    >
                        <Typography><h6 className='titlesociete'>{i18n.t('Compétences fonctionnelles')}</h6></Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <div className='Frame121212'>
                            {Array.isArray(skillsFonc) && skillsFonc.map((skill, i) => (
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: device == 'desktop' ? 'row' : 'column',
                                        justifyContent: 'space-between',
                                        alignSelf: 'stretch',
                                        gap: '16px',
                                    }}
                                    key={i}
                                >
                                    <div style={{ width: device == 'desktop' ? '50%' : '100%' }}>
                                        <p className='row1skillnametxt2'>{i18n.t('Compétence')}</p>
                                        <Autocomplete
                                            id="free-solo-2-demo"
                                            name='titre'
                                            size={inputSize}
                                            freeSolo
                                            options={foncSkillSet.map((option) => option?.title)}
                                            inputValue={skill?.titre || ''}
                                            onInputChange={(event, newInputValue) => {
                                                // setInputValue(newInputValue);
                                                console.log({ event, newInputValue, skillsTech });
                                                let newArr = [...skillsFonc]; // copying the old datas array
                                                newArr[i].titre = newInputValue; // replace e.target.value with whatever you want to change it to
                                                setSkillsFonc(newArr);
                                            }}
                                            sx={{
                                                '& > :not(style)': { borderRadius: '8px' },
                                            }}
                                            style={{ width: '100%', borderRadius: '8px' }}
                                            renderInput={(params) =>
                                                <TextFieldComponent
                                                    {...params}
                                                    sx={{
                                                        '& > :not(style)': { borderRadius: '8px' },
                                                    }}
                                                //onChange={(e)=>{
                                                //    handleInputChangeCompetencesTech(e,i);
                                                //}}
                                                //label=""
                                                //placeholder="Compétence technique"
                                                />}
                                        />
                                    </div>

                                    <div style={{ width: device == 'desktop' ? '25%' : '100%' }}>
                                        <p className='row1skillnametxt2'>{i18n.t('Niveau')}</p>
                                        <SelectComponent
                                            name='niveau'
                                            val={skill?.niveau}
                                            setVal={(e) => {
                                                let newArr = [...skillsFonc]; // copying the old datas array
                                                newArr[i].niveau = e.target.value; // replace e.target.value with whatever you want to change it to
                                                setSkillsFonc(newArr);
                                            }}
                                            listVal={niveauxSkill}
                                        />
                                        {/*<ThemeProvider theme={FieldComponentFont}>
                                            <FormControl fullWidth>
                                                <Select
                                                    size={inputSize}
                                                    name='niveau'
                                                    sx={{
                                                        '& > :not(style)': {borderRadius: '8px'},
                                                    }}
                                                    style={{width:'100%',background:'white'}}
                                                    value={skill?.niveau}
                                                    onChange={(e) => {
                                                        let newArr = [...skillsFonc]; // copying the old datas array
                                                        newArr[i].niveau = e.target.value; // replace e.target.value with whatever you want to change it to
                                                        setSkillsFonc(newArr);
                                                    }}
                                                >
                                                    {niveauxSkill?.map((niveau,j) => (
                                                        <MenuItem
                                                            value={niveau.value}
                                                            key={j}
                                                        > {niveau.label}</MenuItem>
                                                    ))}

                                                </Select>
                                            </FormControl>
                                        </ThemeProvider>                                  */}
                                    </div>

                                    <div style={{ width: device == 'desktop' ? '25%' : '100%' }}>
                                        <p className='row1skillnametxt2'>{i18n.t('Exigence')}</p>
                                        <SelectComponent
                                            name='exigence'
                                            val={skill?.exigence}
                                            setVal={(e) => {
                                                let newArr = [...skillsFonc];
                                                newArr[i].exigence = e.target.value;
                                                setSkillsFonc(newArr);
                                                console.log(e.target.value);
                                            }}
                                            listVal={exigencesEnum}
                                        />
                                        {/*<ThemeProvider theme={FieldComponentFont}>
                                            <FormControl fullWidth>
                                                <Select
                                                    sx={{
                                                        '& > :not(style)': {borderRadius: '8px'},
                                                    }}
                                                    style={{width:'100%',background:'white'}}
                                                    title="exigence"
                                                    size={inputSize}
                                                    value={skill?.exigence}
                                                    onChange={(e) => {
                                                        let newArr = [...skillsFonc];
                                                        newArr[i].exigence = e.target.value;
                                                        setSkillsFonc(newArr);
                                                        console.log(e.target.value);
                                                    }}
                                                >
                                                    {exigencesEnum.map((option) => (
                                                        <MenuItem
                                                            key={option.value}
                                                            value={option.value}
                                                        >
                                                            {option.label}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </ThemeProvider>*/}
                                    </div>

                                    {/*<div style={{ width: '24%' }}>
                                        <p className='row1skillnametxt2'>Plus récente expérience</p>
                                        <SelectComponent
                                            name='experiencePlusRecente'
                                            val={skill?.experiencePlusRecente}
                                            setVal={(e) => {
                                                let newArr = [...skillsFonc];
                                                newArr[i].experiencePlusRecente = e.target.value;
                                                setSkillsFonc(newArr);
                                                console.log(e.target.value);
                                            }}
                                            listVal={plusRecenteExperience}
                                        />
                                    </div>*/}

                                    <div className='btndelete'>
                                        <IconButton
                                            onClick={() => {
                                                const list = [...skillsFonc];
                                                list.splice(i, 1);
                                                setSkillsFonc(list);
                                            }}

                                            aria-label="delete"
                                        >
                                            <DeleteForeverOutlinedIcon />
                                        </IconButton>
                                    </div>
                                </div>
                            ))}

                            <Button
                                style={{ ...buttonStyles(false), ...{ color: '#B0B0B0' } }}
                                variant="text"
                                startIcon={<AddIcon />}
                                onClick={(e) => {
                                    let index = skillsFonc.length;
                                    let newArr = [...skillsFonc]; // copying the old datas array
                                    newArr.push(initializeFoncSkill(index));
                                    // replace e.target.value with whatever you want to change it to
                                    setSkillsFonc(newArr);
                                    console.log(e, skillsFonc);
                                }}
                            >{i18n.t('Ajouter une compétence')}</Button>
                        </div>
                    </AccordionDetails>
                </Accordion>

                <Accordion style={{ width: '100%' }}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                    >
                        <Typography><h6 className='titlesociete'>{i18n.t('Langues')}</h6></Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <div className='Frame121212'>
                            {Array.isArray(langues) && langues.map((lang, i) => (
                                <div
                                    key={i}
                                    style={{
                                        display: 'flex',
                                        flexDirection: device == 'desktop' ? 'row' : 'column',
                                        justifyContent: 'space-between',
                                        alignSelf: 'stretch',
                                        gap: '16px',
                                    }}
                                >

                                    <div style={{ width: device == 'desktop' ? '33%' : '100%' }}>
                                        <p className='row1skillnametxt2'>{i18n.t('Langue')}</p>
                                        <SelectComponent
                                            setVal={e => {
                                                const { value } = e.target;
                                                const list = [...langues];
                                                list[i].langue = value;
                                                setLangues(list);
                                            }}
                                            val={lang?.langue}
                                            name='langue'
                                            listVal={languesList}
                                        />
                                        {/*<ThemeProvider theme={FieldComponentFont}>
                                            <FormControl fullWidth>
                                                <Select
                                                    size={inputSize}
                                                    name='langue'
                                                    value={lang?.langue}
                                                    onChange={(event, newInputValue) => {
                                                        let newArr = [...langues];
                                                        newArr[i].langue = newInputValue;
                                                        setLangues(newArr);
                                                    }}
                                                    sx={{
                                                        '& > :not(style)': {borderRadius: '8px'},
                                                    }}
                                                    style={{width:'100%',background:'white'}}

                                                >
                                                    {languesList?.map((langue,j) => (
                                                        <MenuItem
                                                            value={langue.value}
                                                            key={j}
                                                        > {langue.label}</MenuItem>
                                                    ))}

                                                </Select>
                                            </FormControl>
                                        </ThemeProvider>*/}
                                    </div>

                                    <div style={{ width: device == 'desktop' ? '33%' : '100%' }}>
                                        <p className='row1skillnametxt2'>{i18n.t('Niveau')}</p>
                                        <ThemeProvider theme={FieldComponentFont}>
                                            <FormControl fullWidth>
                                                <Select
                                                    size={inputSize}
                                                    value={lang?.niveau}
                                                    onChange={(e) => {
                                                        let newArr = [...langues]; // copying the old datas array
                                                        newArr[i].niveau = e.target.value; // replace e.target.value with whatever you want to change it to
                                                        setLangues(newArr);
                                                    }}
                                                    name='niveau'
                                                    sx={{
                                                        '& > :not(style)': { borderRadius: '8px' },
                                                    }}
                                                    style={{ width: '100%', background: 'white' }}

                                                >
                                                    {niveauxLangue?.map((niveauLg, j) => (
                                                        <MenuItem
                                                            value={niveauLg.value}
                                                            key={j}
                                                        > {i18n.t(niveauLg.label)}</MenuItem>
                                                    ))}

                                                </Select>
                                            </FormControl>
                                        </ThemeProvider>
                                    </div>

                                    <div style={{ width: device == 'desktop' ? '33%' : '100%' }}>
                                        <p className='row1skillnametxt2'>{i18n.t('Exigence')}</p>
                                        <SelectComponent
                                            name='exigence'
                                            val={lang?.exigence}
                                            setVal={(e) => {
                                                let newArr = [...langues]; // copying the old datas array
                                                newArr[i].exigence = e.target.value; // replace e.target.value with whatever you want to change it to
                                                setLangues(newArr);
                                            }}
                                            listVal={exigencesEnum}
                                        />

                                        {/*<ThemeProvider theme={FieldComponentFont}>
                                            <FormControl fullWidth>
                                                <Select
                                                    sx={{
                                                        '& > :not(style)': {borderRadius: '8px'},
                                                    }}
                                                    style={{width:'100%',background:'white'}}
                                                    title="exigence"
                                                    size={inputSize}
                                                    value={lang?.exigence}
                                                    onChange={(e) => {
                                                        let newArr = [...langues]; // copying the old datas array
                                                        newArr[i].exigence = e.target.value; // replace e.target.value with whatever you want to change it to
                                                        setLangues(newArr);
                                                    }}
                                                >
                                                    {exigencesEnum.map((option) => (
                                                        <MenuItem
                                                            key={option.value}
                                                            value={option.value}
                                                        >
                                                            {option.label}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </ThemeProvider>*/}
                                    </div>

                                    <div className='btndelete'>
                                        <IconButton
                                            onClick={(e) => {
                                                // delete the index element by distructuring the array in two part without taking the i element
                                                let newArr1 = [
                                                    ...langues.slice(0, i),
                                                    ...langues.slice(i + 1, langues.length),
                                                ];
                                                setLangues(newArr1);
                                                console.log(e, langues);
                                            }}

                                            aria-label="delete"
                                        >
                                            <DeleteForeverOutlinedIcon />
                                        </IconButton>
                                    </div>
                                </div>
                            ))}

                            <Button
                                style={{ ...buttonStyles(false), ...{ color: '#B0B0B0' } }}
                                variant="text"
                                startIcon={<AddIcon />}
                                onClick={(e) => {
                                    // e.preventDefault()
                                    let index = langues.length;
                                    let newArr = [...langues]; // copying the old datas array
                                    newArr.push(initializeLangue(index));
                                    // replace e.target.value with whatever you want to change it to
                                    setLangues(newArr);
                                    console.log(e, langues);
                                }}
                            >{i18n.t('Ajouter une langue')}</Button>
                        </div>
                    </AccordionDetails>
                </Accordion>

                <Accordion style={{ width: '100%' }}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                    >
                        <Typography><h6 className='titlesociete'>{i18n.t('Certificats')}</h6></Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <div className='Frame121212'>
                            {Array.isArray(certifs) && certifs.map((certif, i) => (
                                <div
                                    key={i}
                                    style={{
                                        display: 'flex',
                                        flexDirection: device == 'desktop' ? 'row' : 'column',
                                        justifyContent: 'space-between',
                                        alignSelf: 'stretch',
                                        gap: '16px',
                                    }}
                                >
                                    <div style={{ width: device == 'desktop' ? '48%' : '100%' }}>
                                        <p className='row1skillnametxt2'>{i18n.t('Intitulé')}</p>
                                        <TextFieldComponent
                                            sx={{
                                                '& > :not(style)': { borderRadius: '8px' },
                                            }}
                                            style={{ width: '100%', background: 'white' }}
                                            placeholder={i18n.t('Nom du certificat')}
                                            value={certif?.titre}
                                            onChange={(e) => {
                                                let newArr = [...certifs]; // copying the old datas array
                                                newArr[i].titre = e.target.value; // replace e.target.value with whatever you want to change it to
                                                setCertifs(newArr);
                                            }}
                                        />
                                    </div>

                                    <div style={{ width: device == 'desktop' ? '48%' : '100%' }}>
                                        <p className='row1skillnametxt2'>{i18n.t('Exigence')}</p>
                                        <SelectComponent
                                            name='exigence'
                                            val={certif?.exigence}
                                            setVal={(e) => {
                                                let newArr = [...certifs]; // copying the old datas array
                                                newArr[i].exigence = e.target.value; // replace e.target.value with whatever you want to change it to
                                                setCertifs(newArr);
                                            }}
                                            listVal={exigencesEnum}
                                        />

                                        {/* <ThemeProvider theme={FieldComponentFont}>
                                            <FormControl fullWidth>
                                                <Select
                                                    sx={{
                                                        '& > :not(style)': {borderRadius: '8px'},
                                                    }}
                                                    style={{width:'100%',background:'white'}}
                                                    title="exigence"
                                                    size={inputSize}
                                                    value={certif?.exigence}
                                                    onChange={(e) => {
                                                        let newArr = [...certifs]; // copying the old datas array
                                                        newArr[i].exigence = e.target.value; // replace e.target.value with whatever you want to change it to
                                                        setCertifs(newArr);
                                                    }}
                                                >
                                                    {exigencesEnum.map((option) => (
                                                        <MenuItem
                                                            key={option.value}
                                                            value={option.value}
                                                        >
                                                            {option.label}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </ThemeProvider>*/}

                                    </div>
                                    <div className='btndelete'>
                                        <IconButton
                                            onClick={(e) => {
                                                // delete the index element by distructuring the array in two part without taking the i element
                                                let newArr1 = [
                                                    ...certifs.slice(0, i),
                                                    ...certifs.slice(i + 1, certifs.length),
                                                ];
                                                setCertifs(newArr1);
                                                console.log(e, certifs);
                                            }}

                                            aria-label="delete"
                                        >
                                            <DeleteForeverOutlinedIcon />
                                        </IconButton>
                                    </div>
                                </div>
                            ))}

                            <Button
                                variant="text"
                                style={{ ...buttonStyles(false), ...{ color: '#B0B0B0' } }}
                                startIcon={<AddIcon />}
                                onClick={(e) => {
                                    let index = certifs.length;
                                    let newArr = [...certifs]; // copying the old datas array
                                    newArr.push(initializeCertif(index));
                                    // replace e.target.value with whatever you want to change it to
                                    setCertifs(newArr);
                                    console.log(e, certifs);
                                }}
                            >
                                {i18n.t('Ajouter une qualification')}
                            </Button>
                        </div>
                    </AccordionDetails>
                </Accordion>
                {location?.state?.aoId ?
                    <div className='Frame010101'>
                        <Button
                            style={{ ...buttonStyles(false) }}
                            variant="outlined"
                            onClick={(e) => {
                                e.preventDefault();
                                navigate(`/${role}/aos`);
                            }}
                        >
                            {i18n.t('Retour aux AO')}
                        </Button>
                        <Button
                            //style={{ backgroundColor: '#214DCE', width: '150px', height: '56px', fontFamily: 'Lato', fontStyle: 'normal', fontWeight: 600, fontSize: '12px', lineHeight: '32px', alignItems: 'center', textAlign: 'center', letterSpacing: '-0.15px', color: 'white', borderRadius: '8px' }}
                            style={{ ...buttonStylesBlue(), ...{ width: device == 'desktop' ? 'auto' : '100%' } }}
                            type="submit"
                            className='ButtonSubmit'
                            onClick={(e) => {
                                createAO_step3({ e: e });
                            }}
                        >
                            {i18n.t('Sauvegarder')}
                        </Button>
                    </div>
                    :
                    <div style={{ display: 'flex', flexDirection: device == 'desktop' ? 'row' : 'column', justifyContent: 'space-between', alignItems: 'flex-start', alignSelf: 'stretch', gap: device == 'desktop' ? '0px' : '16px' }}>
                        <div
                            className='BtnFrame'
                            style={{ order: device == 'desktop' ? '0' : '1' }}
                        >

                            <Button
                                variant='outlined'
                                style={{ ...buttonStyles(), ...{ color: '#214DCE', width: device == 'desktop' ? 'auto' : '100%' } }}
                                //style={{height: '56px',width:'100px', borderRadius:'8px',fontFamily: 'Lato', fontStyle: 'normal', fontWeight: 600, fontSize: '12px', lineHeight: '32px', alignItems: 'center', textAlign: 'center',color: '#214DCE' }}
                                onClick={navigateToStep2WithSavedData}
                            >
                                {i18n.t('Retour')}
                            </Button>
                        </div>
                        <div
                            className='SSBtn'
                            style={{ flexDirection: device == 'desktop' ? 'row' : 'column', order: device == 'desktop' ? '1' : '0' }}
                        >
                            {role == 'client' &&
                                <Button
                                    //style={{...buttonStylesGreen(false),...{width: '164px'}}}
                                    style={{ ...buttonStyles(), ...{ color: '#5CC889', width: device == 'desktop' ? 'auto' : '100%', order: device == 'desktop' ? '0' : '2' } }}
                                    //className='savebtn'
                                    variant='text'
                                    //style={{ height: '56px', fontFamily: 'Lato',borderRadius:'8px', fontStyle: 'normal', fontWeight: 600, fontSize: '12px', lineHeight: '32px', alignItems: 'center', textAlign: 'center',color: '#5CC889'}}
                                    onClick={() => navigate(`/${role}/ao/aoDetails/${selectedAO?._id}`, { state: { isFromCreateAO: true } })}
                                >
                                    {i18n.t('Visualiser')}
                                </Button>}
                            {role == 'client' &&
                                <Button
                                    //style={{height: '56px', fontFamily: 'Lato', borderRadius:'8px', fontStyle: 'normal', fontWeight: 600, fontSize: '12px', lineHeight: '32px', alignItems: 'center', textAlign: 'center',color: '#5CC889'}}
                                    style={{ ...buttonStyles(), ...{ color: '#5CC889', width: device == 'desktop' ? 'auto' : '100%', order: device == 'desktop' ? '1' : '1' } }}
                                    //className='savebtn'
                                    variant='text'
                                    onClick={(e) => {
                                        createAO_step3({ e: e, action: 'save' });
                                    }}
                                >
                                    {i18n.t('Sauvegarder')}
                                </Button>}
                            <Button
                                type="submit"
                                style={{ ...buttonStylesGreen(false), ...{ width: device == 'desktop' ? '120px' : '100%', order: device == 'desktop' ? '2' : '0' } }}
                                onClick={(e) => {
                                    createAO_step3({ e: e, action: 'validate' });
                                }}
                            >
                                {i18n.t('Valider')}
                            </Button>

                        </div>
                    </div>
                }
            </div>
        </>
    );
}

export default CreateAOThird;

{/* <Form.Control
                                                type="text"
                                                className='col-3'
                                                style={{
                                                    width: "50%",
                                                    // color: "red"
                                                }}
                                                // defaultValue={skill}
                                                onChange={(e) => {
                                                    // let newArr = [...skillTechState]; // copying the old datas array
                                                    // newArr[i].titre = e.target.value; // replace e.target.value with whatever you want to change it to
                                                    // setSkillTechState(newArr);
                                                }}
/> */}
{
    /* <p>
                                              Date Certifications:
                                          </p>
                                          <Form.Control type="text"
                                              // defaultValue={certif?.date}
                                              onChange={(e) => {
                                                  let newArr = [...certifStates]; // copying the old datas array
                                                  newArr[i].date = e.target.value; // replace e.target.value with whatever you want to change it to
                                                  setCertifState(newArr);
                                              }}
                                          /> */
}

{
/**
 *                     <Accordion.Item eventKey="1">
                        <Accordion.Header>Certifications #2</Accordion.Header>
                        <Accordion.Body>
                            {state?.data.certifications?.length
                                ? (
                                    <div>
                                        {state?.data.certifications.map((certif, i) => (
                                            <div key={i}>
                                                <p>
                                                    Date Certifications:
                                                </p>
                                                <Form.Control type="text" defaultValue={certif?.date}
                                                    onChange={(e) => {
                                                        let newArr = [...certifStates]; // copying the old datas array
                                                        newArr[i].date = e.target.value; // replace e.target.value with whatever you want to change it to
                                                        setCertifState(newArr);
                                                    }
                                                    }
                                                />
                                                <p>
                                                    Titre:
                                                </p>
                                                <FloatingLabel controlId="floatingTextarea2"
                                                // label="Certifs"
                                                >
                                                    <Form.Control
                                                        as="textarea"
                                                        placeholder="Leave a comment here"
                                                        style={{ height: '100px' }}
                                                        defaultValue={certif?.text}
                                                        onChange={(e) => {
                                                            let newArr = [...certifStates]; // copying the old datas array
                                                            newArr[i].text = e.target.value; // replace e.target.value with whatever you want to change it to
                                                            setCertifState(newArr);
                                                        }
                                                        }
                                                    />
                                                </FloatingLabel>

                                                <hr style={styleHr} />
                                            </div>
                                        )
                                        )
                                        }
                                    </div>
                                ) : <p>No certifications to display</p>
                            }
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="2">
                        <Accordion.Header>Diplomes #3</Accordion.Header>
                        <Accordion.Body>
                            {state?.data.diplomes?.length
                                ? (
                                    <div>
                                        {state?.data.diplomes.map((diplome, i) => (
                                            <div key={i}>
                                                <p>
                                                    Date Diplome:
                                                </p>
                                                <Form.Control type="text" defaultValue={diplome?.date}
                                                    onChange={(e) => {
                                                        let newArr = [...diplomeState]; // copying the old datas array
                                                        newArr[i].date = e.target.value; // replace e.target.value with whatever you want to change it to
                                                        setDiplomeState(newArr);
                                                    }
                                                    }
                                                />
                                                <p>
                                                    Titre:
                                                </p>
                                                <FloatingLabel controlId="floatingTextarea2"
                                                // label="Diplomes"
                                                >
                                                    <Form.Control
                                                        as="textarea"
                                                        placeholder="Leave a comment here"
                                                        style={{ height: '100px' }}
                                                        defaultValue={diplome?.text}
                                                        onChange={(e) => {
                                                            let newArr = [...diplomeState]; // copying the old datas array
                                                            newArr[i].text = e.target.value; // replace e.target.value with whatever you want to change it to
                                                            setDiplomeState(newArr);
                                                        }
                                                        }
                                                    />
                                                </FloatingLabel>
                                                <hr style={styleHr} />
                                            </div>
                                        )
                                        )
                                        }
                                    </div>
                                ) : <p>No diplomes to display</p>
                            }
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="3">
                        <Accordion.Header>Langues #4</Accordion.Header>
                        <Accordion.Body>
                            {state?.data.langue?.length
                                ? (
                                    <div>
                                        {state?.data.langue.map((lang, i) => (
                                            <div key={i} style={{
                                                display: "inline-block"
                                            }}>
                                                <p>
                                                    Langues:
                                                </p>
                                                <Form.Control type="text"
                                                    defaultValue={lang}
                                                    placeholder="Leave a comment here"
                                                    style={{ height: '100px' }}
                                                    onChange={(e) => {
                                                        let newArr = [...langueState]; // copying the old datas array
                                                        newArr[i].langue = e.target.value; // replace e.target.value with whatever you want to change it to
                                                        setLangueState(newArr);
                                                    }
                                                    }
                                                />
                                                <Form.Select   variant="secondary"
                                                    title="niveau de langues">
                                                    <option >notion</option>
                                                    <option >pro</option>
                                                    <option >avance</option>
                                                    <option >bilingue</option>
                                                </Form.Select>
                                                <hr style={styleHr} />
                                            </div>
                                        )
                                        )
                                        }
                                    </div>
                                ) : <p>No Langues to display</p>
                            }
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="4">
                        <Accordion.Header>Skills Techniques #5</Accordion.Header>
                        <Accordion.Body>
                            {state?.data.skills_tech?.length
                                ? (
                                    <div>
                                        {state?.data.skills_tech.map((skill, i) => (
                                            <div key={i}>

                                                <Form.Control
                                                    type="text" defaultValue={skill}
                                                    onChange={(e) => {
                                                        let newArr = [...skillTechState]; // copying the old datas array
                                                        newArr[i].titre = e.target.value; // replace e.target.value with whatever you want to change it to
                                                        setSkillTechState(newArr);
                                                    }
                                                    }
                                                />
                                                <hr style={styleHr} />
                                            </div>
                                        )
                                        )
                                        }
                                    </div>
                                ) : <p>No Skills Techniques to display</p>
                            }
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="5">
                        <Accordion.Header>Skills Fonctionnels #6</Accordion.Header>
                        <Accordion.Body>
                            <div>

                                <FloatingLabel controlId="floatingTextarea2"
                                // label="Skills_Fonct"
                                >
                                    <Form.Control
                                        as="textarea"
                                        placeholder="Leave a comment here"
                                        style={{ height: '100px' }}
                                        defaultValue={state?.data?.skills_fonc}
                                        onChange={(e) => {
                                            console.log(state?.data.skills_fonc);
                                            // console.log(e.target.defaultValue);
                                            // console.log(e.target.value);
                                            state?.data.skills_fonc = e.target.value
                                            // let newArr = [...langueState]; // copying the old datas array
                                            // newArr[i].langue = e.target.value; // replace e.target.value with whatever you want to change it to
                                            // setLangueState(newArr);
                                        }
                                        }
                                    />
                                </FloatingLabel>
                            </div>
                        </Accordion.Body>
                    </Accordion.Item>
                                    */}
